import React from 'react'

import { Resource } from '@/payload-types'
import { GridBlock } from '@/components'

interface ResourceListProps {
  items: Resource[]
}

function ResourceList({ items }: Readonly<ResourceListProps>) {
  if (items.length === 0) return null

  return (
    <GridBlock
      blockType="grid"
      items={items.map((resource) => ({
        relationTo: 'resources' as const,
        value: resource,
      }))}
    />
  )
}

export { ResourceList }
